module.exports = __webpack_public_path__ + "img/logo_long.d285284e.jpeg";